module.exports = __webpack_public_path__ + "media/img/legal/legal-86466a65d2ff58af2fe1165f62b80e7d.jpg";